import React, { useState } from 'react'
import reactCSS from 'reactcss'
import { SketchPicker } from 'react-color'

const ColorPicker = ({ onChange, color = "#D63F3F", disabled }) => {
  const [displayColorPicker, setDisplayColorPicker] = useState(false)

  const handleClick = () => {
    setDisplayColorPicker(!displayColorPicker)
  }

  const handleClose = () => {
    setDisplayColorPicker(false)
  }

  const handleChange = (color) => {
    onChange(color.hex)
  }


  const styles = reactCSS({
    'default': {
      color: {
        width: '32px',
        height: '18px',
        borderRadius: '2px',
        background: color,
      },
      swatch: {
        padding: '3px',
        background: '#fff',
        borderRadius: '1px',
        boxShadow: '0 0 0 1px #F0EBF9',
        display: 'inline-block',
        cursor: 'pointer',
      },
      popover: {
        position: 'absolute',
        zIndex: '2',
      },
      cover: {
        position: 'fixed',
        top: '0px',
        right: '0px',
        bottom: '0px',
        left: '0px',
      },
    },
  })

  return (
    <div>
      <div style={ styles.swatch } onClick={disabled ? () => {} : handleClick}>
        <div style={ styles.color } />
      </div>
      { displayColorPicker ? <div style={ styles.popover }>
        <div style={ styles.cover } onClick={handleClose}/>
        <SketchPicker color={ color } onChange={handleChange} />
      </div> : null }

    </div>
  )
}

export default ColorPicker